import { Link } from 'react-router-dom'

interface FooterProps {
  onContact: () => void
}

const linkClass =
  'text-black dark:text-white hover:text-[#0f637b] dark:hover:text-[#04daf6] transition-colors'
const rowLinkClass = `${linkClass} inline-flex items-center min-h-[44px] md:min-h-0 md:py-1.5 whitespace-nowrap`

function Separator() {
  return (
    <span aria-hidden="true" className="text-neutral-400 dark:text-neutral-600">
      ·
    </span>
  )
}

export default function Footer({ onContact }: FooterProps) {
  return (
    <footer className="relative z-10 px-5 sm:px-7 pt-6 pb-6 sm:pb-7 text-sm font-normal text-neutral-600 dark:text-neutral-400">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-2 md:gap-8">
        <div>
          <nav aria-label="Quick links" className="flex flex-wrap items-center gap-x-2.5 text-[13px]">
            <a href="https://suite.candlefish.ai" className={rowLinkClass}>Suite</a>
            <Separator />
            <a href="https://etchexpress.ai" className={rowLinkClass}>Etch Express</a>
            <Separator />
            <a href="https://dealbook.candlefish.ai" className={rowLinkClass}>Dealbook</a>
          </nav>
          <p className="leading-relaxed">
            <strong className="font-bold text-black dark:text-white">
              Candlefish focuses on results based optimization through transformative technologies.
            </strong>
            <br />
            Use is subject to our{' '}
            <Link to="/terms" className={linkClass}>Terms of Service</Link>
            {' '}and{' '}
            <Link to="/privacy" className={linkClass}>Privacy Policy</Link>.
          </p>
        </div>

        <nav aria-label="Contact and social" className="flex flex-wrap items-center gap-x-2.5 md:justify-end">
          <button type="button" onClick={onContact} className={rowLinkClass}>
            Get in touch
          </button>
          <Separator />
          <a
            href="https://github.com/candlefish-ai"
            target="_blank"
            rel="noopener noreferrer"
            className={rowLinkClass}
          >
            GitHub
          </a>
          <Separator />
          <a
            href="https://www.linkedin.com/company/candlefish-ai/"
            target="_blank"
            rel="noopener noreferrer"
            className={rowLinkClass}
          >
            LinkedIn
          </a>
        </nav>
      </div>
    </footer>
  )
}
